import {FormattedMessage, IntlShape} from 'react-intl';
import {Condition} from '.cache/__types__';

export const translations = {
    [Condition.Undefined]: <FormattedMessage defaultMessage="Nevyplněno" />,
    [Condition.New]: <FormattedMessage defaultMessage="Novostavba" />,
    [Condition.VeryGood]: <FormattedMessage defaultMessage="Velmi dobrý" />,
    [Condition.Good]: <FormattedMessage defaultMessage="Dobrý" />,
    [Condition.Bad]: <FormattedMessage defaultMessage="Špatný" />,
    [Condition.Demolition]: <FormattedMessage defaultMessage="K demolici" />,
    [Condition.Construction]: <FormattedMessage defaultMessage="Ve výstavbě" />,
};

export const translationsString = {
    [Condition.Undefined]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Nevyplněno'}),
    [Condition.New]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Novostavba'}),
    [Condition.VeryGood]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Velmi dobrý'}),
    [Condition.Good]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Dobrý'}),
    [Condition.Bad]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Špatný'}),
    [Condition.Demolition]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'K demolici'}),
    [Condition.Construction]: (intl: IntlShape) => intl.formatMessage({defaultMessage: 'Ve výstavbě'}),
};

export const getTranslationString = (intl: IntlShape, key: Condition) => translationsString[key](intl);
